import { render, staticRenderFns } from "./PayrunWizard.vue?vue&type=template&id=3952e795"
import script from "./PayrunWizard.vue?vue&type=script&lang=js"
export * from "./PayrunWizard.vue?vue&type=script&lang=js"
import style0 from "./PayrunWizard.vue?vue&type=style&index=0&id=3952e795&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports